import * as tslib_1 from "tslib";
import * as UserNotificationActionModal from 'raw-loader!src/app/public/app/shared/userNotifications/user-notifications-actions-modal.html';
import * as CandidateJobMatchCardReportModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-report-modal.html';
var UserNotificationsController = /** @class */ (function () {
    /*@ngInject*/
    function UserNotificationsController($rootScope, $state, $filter, $uibModal, $timeout, StorageService, planService, companyService, requisitionService, jobService, userRoleService, utilityService, debounceService, alertsAndNotificationsService, webSocketsService, dateTimeUtilityService, MESSAGECONSTANTS, notificationsService, sharedAjsService, modalService, outreachService, candidateService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.planService = planService;
        this.companyService = companyService;
        this.jobService = jobService;
        this.requisitionService = requisitionService;
        this.userRoleService = userRoleService;
        this.utilityService = utilityService;
        this.debounceService = debounceService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.webSocketsService = webSocketsService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.notificationsService = notificationsService,
            this.sharedAjsService = sharedAjsService;
        this.modalService = modalService;
        this.outreachService = outreachService;
        this.candidateService = candidateService;
    }
    UserNotificationsController.prototype.$onInit = function () {
        //flags
        this.showShortMessagesFlag = true;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        //variables
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.searchObjectStartDate = null;
        this.searchObjectEndDate = null;
        this.searchNotifications = _.debounce(this.searchNotifications, 500);
        //objects
        this.filterObject = {};
        this.fullClientsList = [];
        this.selectedClients = [];
        this.fullRolesList = [];
        this.selectedRoles = [];
        this.fullReqNumList = [];
        this.selectedRequisitionNumbers = [];
        if (_.isUndefined(this.height)) {
            this.height = '400px';
        }
        if (_.isUndefined(this.width)) {
            this.width = '100%';
        }
        if (_.isUndefined(this.viewAllFlag)) {
            this.viewAllFlag = false;
        }
        if (_.isUndefined(this.viewAllMode)) {
            this.viewAllMode = 'modal';
        }
        if (_.isUndefined(this.context)) {
            this.context = 'global';
        }
        if (_.isUndefined(this.userNotificationControls)) {
            this.userNotificationControls = {};
        }
        if (_.isUndefined(this.numberOfNewNotifications)) {
            this.numberOfNewNotifications = 0;
        }
        if (_.isUndefined(this.showFilters)) {
            this.showFilters = false;
        }
        if (this.showFilters) {
            this._initializeDateAndTimePickersForFilters();
            this.getNotificationTypes();
            if (this.context == 'global') {
                this._getFilters();
            }
            // do not show short messages because this is the full notifications view.
            this.showShortMessagesFlag = false;
        }
        this.notificationsContainer = new NotificationsContainer(this.$rootScope, this.context, this.showShortNotification, this.searchObject, this.showFilters, this.fullView, this.alertsAndNotificationsService, this.notificationsService, this.isStaffingCompany, this.outreachService);
        this.userNotificationControls.setNewNotificationsAsViewed = this.notificationsContainer.setNewNotificationsAsViewed();
        this.filterObject.text = '';
        this._initializeNotificationReceive();
        this._setSearchEvents();
    };
    UserNotificationsController.prototype.$onChanges = function (changes) {
        if (this.userNotificationControls && this.userNotificationControls.notificationClickCount > 0 && this.notificationsContainer) {
            this.notificationsContainer.isNotificationIconClicked = true;
            //enable infinite scrolling if icon is clicked and notifications exist
            if (this.notificationsContainer.notificationsExistFlag) {
                this.notificationsContainer.disableInfiniteScroll = false;
            }
            this.notificationsContainer.setNewNotificationsAsViewed();
        }
        this.userNotificationControls.notificationClickCount++;
    };
    UserNotificationsController.prototype._getFilters = function () {
        var _this = this;
        this.getNotificationTypes();
        this._getClientsOrBus(function () {
            _this._getRoles("all");
            _this.getRequisitionNumbers("all");
        });
    };
    UserNotificationsController.prototype._setSearchEvents = function () {
        $(document).ready(function () {
            $("#user-notifications-search-panel").hide();
            $(document).off("click", "#user-notifications-open-filter").on("click", "#user-notifications-open-filter", function () {
                $("#user-notifications-search-panel").animate({
                    height: 'toggle'
                });
            });
            // $("#userNotificationsClientName").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsCandidateFirstName").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsCandidateLastName").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsRequisitionNumber").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsJobTitle").keyup(this.debounceService.debounce(this.searchNotifications, 500));
        });
    };
    UserNotificationsController.prototype.resetSearchFilters = function () {
        this.notificationsContainer.searchObject = new SearchObject(this.$rootScope.userDetails.company.companyId);
        //$("#timeBoundStartDate").datepicker("setDate", currentDate);
        this.searchObjectStartDate = '';
        this.searchObjectEndDate = '';
        this.searchNotifications();
    };
    ;
    UserNotificationsController.prototype.searchNotifications = function () {
        var _this = this;
        // Check if there's already a request in progress
        if (this.notificationsContainer.busy) {
            // Search already in progress, skipping duplicate call
            return;
        }
        this.notificationsContainer.searchObject.page = "";
        this.notificationsContainer.currentPromise = null;
        this.notificationsContainer.disableInfiniteScroll = false;
        this.notificationsContainer.notificationsExistFlag = true;
        this.notificationsContainer.notifications = [];
        this.notificationsContainer.newNotifications = [];
        this.notificationsContainer.searchObject.clientOrBuIds = this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
        this.notificationsContainer.searchObject.roleNames = this.selectedRoles.map(function (role) { return role.name; });
        this.notificationsContainer.searchObject.reqNumbers = this.selectedRequisitionNumbers.map(function (req) { return req.name; });
        this.notificationsContainer.notificationCalledOnce = 0;
        this.notificationsContainer.getNext(this);
        // Wait until first getNext() finishes (busy = false)
        var trySecondLoad = function () {
            // Trigger getNext() when filtered count is less than original count (20)
            if (!_this.notificationsContainer.busy) {
                // Now originalCount and filteredCount are available
                if (_this.notificationsContainer.notificationCalledOnce <= 1 &&
                    _this.notificationsContainer.originalNotificationCount > _this.notificationsContainer.filteredNotificationCount) {
                    // Trigger second load safely
                    _this.notificationsContainer.getNext(_this);
                }
            }
            else {
                // Retry until busy becomes false
                _this.$timeout(trySecondLoad, 100);
            }
        };
        this.$timeout(trySecondLoad, 100);
    };
    UserNotificationsController.prototype._initializeNotificationReceive = function () {
        var _this = this;
        this.webSocketsService.receive().then(null, null, function (message) {
            // message = {"notificationId":"2fc4ed38-0d23-47be-b88b-2b175b3bbb9e","companyId":"5c80ee5580ee22475e8e1dd4","clientOrBUId":null,"jobId":null,"candidateId":null,"jobMatchId":null,"eventId":"63a58e1980ee223127b85eec","alertId":null,"recipientId":"58776d60e4b0b349ba70cad8","recipientType":"USER","mode":"UI","status":null,"state":"NEW","text":"RESUME Scoring has finished for all '5' candidates","notifyOn":["GLOBAL"],"createdDate":"2022-12-23T11:16:41Z","lastModifiedDate":"2022-12-23T11:16:41Z","operation":"new","taggedText":"RESUME Scoring has finished for all <4dot5>'5'</4dot5> candidates","jbiTransactionId":null,"eventType":"REQUISITION_RE_RUN_SCORING","assessmentType":null,"testInvitationId":null,"redirect":null,"candidateScreenRedirect":null,"participantJoinDetails":null,"approverName":null,"participantRemovedBy":null,"feedbackEditEnabledUserName":null,"requesterName":null,"requesterAttendeeId":null,"primaryHostAttendeeId":null,"personInWaitingRoom":null,"candidateDtoMap":{"unProcessedCandidates":[{"candidateId":"63997cd680ee225dd7e9d890","firstName":"Daryl","lastName":"Ventura","phone":null,"email":"testvil@test.test","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067439-Daryl Ventura.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9580ee223127b85cae","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"5f2a80d780ee227f30d52d01","firstName":"Debbie","lastName":"Burgess","phone":null,"email":"testtt.0.2@4dot5.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067435-Debbie Burgess.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85caf","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63997cdd80ee225dd7e9d92d","firstName":"Dan","lastName":"Marks","phone":null,"email":"danlmarks@mchsi.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067423-Dan Marks.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85cb0","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"candidates":[{"candidateId":"63a58d9880ee223127b85ccc","firstName":"Bhaskar","lastName":"Kanumuru","phone":null,"email":null,"score":1.0,"jobThresholdScore":50.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9380ee223127b85cac","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63a58d9980ee223127b85cd2","firstName":"Anusuya","lastName":"R","phone":null,"email":null,"score":1.0,"jobThresholdScore":40.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9380ee223127b85cad","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63997cd680ee225dd7e9d890","firstName":"Daryl","lastName":"Ventura","phone":null,"email":"testvil@test.test","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067439-Daryl Ventura.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9580ee223127b85cae","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"5f2a80d780ee227f30d52d01","firstName":"Debbie","lastName":"Burgess","phone":null,"email":"testtt.0.2@4dot5.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067435-Debbie Burgess.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85caf","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63997cdd80ee225dd7e9d92d","firstName":"Dan","lastName":"Marks","phone":null,"email":"danlmarks@mchsi.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067423-Dan Marks.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85cb0","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"notProcessedCount":"0","uploadedCandidatesCount":"5","update":{"activeCandidatesCount":0,"passiveCandidatesCount":0,"matchedCandidateCount":5,"unMatchedCandidateCount":0,"justAddedCandidateCount":0,"notProcessedCandidateCount":0,"manuallyMatchedCandidateCount":0,"candidateList":[],"matchedCandidateIdAndNames":[{"candidateId":"63a58d9880ee223127b85ccc","candidateName":"Bhaskar Kanumuru"},{"candidateId":"63a58d9980ee223127b85cd2","candidateName":"Anusuya R"},{"candidateId":"63997cd680ee225dd7e9d890","candidateName":"Daryl Ventura"},{"candidateId":"5f2a80d780ee227f30d52d01","candidateName":"Debbie Burgess"},{"candidateId":"63997cdd80ee225dd7e9d92d","candidateName":"Dan Marks"}],"unMatchedCandidateIdAndNames":[],"candidatesSuspendedPeriod":0,"allowOverride":false}},"allowedToEditFeedback":false,"primaryHost":false, "requisitionScreenRedirect":{"screenName":null,"jobId":"65dc7c1b80ee22680c8b3e19","candidateId":"66065c9280ee2234553c8669","requisitionNumber":"REQ-5","candidateName":null,"candidateEmail":"vish77@gmail.com","candidateType":null,"vendorCandidate":false}};
            // message = {"notificationId":null,"companyId":"5c80ee5580ee22475e8e1dd4","clientOrBUId":null,"jobId":null,"candidateId":null,"jobMatchId":null,"eventId":"63a5858e80ee2209a139bd52","alertId":null,"recipientId":"58776d60e4b0b349ba70cad8","recipientType":"USER","mode":"UI","status":null,"state":"NEW","text":"RESUME Scoring has finished for all '2' candidates","notifyOn":["GLOBAL"],"createdDate":"2022-12-23T10:40:14Z","lastModifiedDate":"2022-12-23T10:40:14Z","operation":"new","taggedText":"RESUME Scoring has finished for all <4dot5>'2'</4dot5> candidates","jbiTransactionId":null,"eventType":"RESUME_SCORE_SYNC_COMPLETED","assessmentType":null,"testInvitationId":null,"redirect":null,"candidateScreenRedirect":null,"participantJoinDetails":null,"approverName":null,"participantRemovedBy":null,"feedbackEditEnabledUserName":null,"requesterName":null,"requesterAttendeeId":null,"primaryHostAttendeeId":null,"personInWaitingRoom":null,"candidateDtoMap":{"candidates":[{"candidateId":null,"firstName":null,"lastName":null,"phone":null,"email":null,"score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":null,"newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":null,"firstName":null,"lastName":null,"phone":null,"email":null,"score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":null,"newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"notProcessedCount":"2","uploadedCandidatesCount":"2","update":{"activeCandidatesCount":0,"passiveCandidatesCount":0,"matchedCandidateCount":0,"unMatchedCandidateCount":0,"justAddedCandidateCount":0,"notProcessedCandidateCount":0,"manuallyMatchedCandidateCount":0,"candidateList":[],"matchedCandidateIdAndNames":[],"unMatchedCandidateIdAndNames":[],"candidatesSuspendedPeriod":0,"allowOverride":false}},"primaryHost":false,"allowedToEditFeedback":false}
            // message = {"notificationId":"b6f623e6-7f80-4182-8169-d9666d79b5d9","companyId":"5c80ee5580ee22475e8e1dd4","clientOrBUId":null,"jobId":"5da05e9e80ee2278a51d6a52","candidateId":null,"jobMatchId":null,"eventId":"63a5a0f880ee221b43818dfb","alertId":null,"recipientId":"58776d60e4b0b349ba70cad8","recipientType":"USER","mode":"UI","status":null,"state":"NEW","text":"RESUME Scoring has finished for all '2' candidates","notifyOn":["GLOBAL"],"createdDate":"2022-12-23T12:37:12Z","lastModifiedDate":"2022-12-23T12:37:12Z","operation":"new","taggedText":"RESUME Scoring has finished for all <4dot5>'2'</4dot5> candidates","jbiTransactionId":null,"eventType":"RESUME_SCORE_SYNC_COMPLETED","assessmentType":null,"testInvitationId":null,"redirect":null,"candidateScreenRedirect":null,"participantJoinDetails":null,"approverName":null,"participantRemovedBy":null,"feedbackEditEnabledUserName":null,"requesterName":null,"requesterAttendeeId":null,"primaryHostAttendeeId":null,"personInWaitingRoom":null,"candidateDtoMap":{"unProcessedCandidates":[{"candidateId":"5f30d07080ee2216f39a3be6","firstName":"Amy","lastName":"Buckner","phone":null,"email":"candidat7112@rightskillnow.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950803-Amy Buckner.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc5","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"6171f16d80ee22473279c5ed","firstName":"AMIT","lastName":"BANSAL","phone":null,"email":"amitb1126@gmail.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950793-AMITHA BANSAL.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc4","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"candidates":[{"candidateId":"5f30d07080ee2216f39a3be6","firstName":"Amy","lastName":"Buckner","phone":null,"email":"candidat7112@rightskillnow.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950803-Amy Buckner.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc5","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"6171f16d80ee22473279c5ed","firstName":"AMIT","lastName":"BANSAL","phone":null,"email":"amitb1126@gmail.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950793-AMITHA BANSAL.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc4","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"notProcessedCount":"0","uploadedCandidatesCount":"2","update":{"activeCandidatesCount":0,"passiveCandidatesCount":0,"matchedCandidateCount":2,"unMatchedCandidateCount":0,"justAddedCandidateCount":0,"notProcessedCandidateCount":0,"manuallyMatchedCandidateCount":0,"candidateList":[],"matchedCandidateIdAndNames":[{"candidateId":"5f30d07080ee2216f39a3be6","candidateName":"Amy Buckner"},{"candidateId":"6171f16d80ee22473279c5ed","candidateName":"AMIT BANSAL"}],"unMatchedCandidateIdAndNames":[],"candidatesSuspendedPeriod":0,"allowOverride":false}},"allowedToEditFeedback":false,"primaryHost":false};
            var performChangeFlag = false;
            // Do not show banner message under notifications
            if (message.notifyOn.indexOf('BANNER') != -1) {
                if (message.eventType === "PLAN_EXPIRATION_WARNING" || message.eventType === "CURRENT_PLAN_ACTIVATED") {
                    _this._savePlanDetails();
                }
                else {
                    _this._setCompanyState(message.text);
                }
            }
            else if (message.notifyOn.indexOf('SNACK_BAR') != -1 && message.eventType === "ASSESSMENTS_SYNC") {
                _this._displayAssessmentsSyncMessage(message.taggedText);
            }
            //Show notifications
            else {
                if (_this.context == 'global') {
                    if (message.notifyOn.indexOf('NO_GLOBAL') == -1) {
                        performChangeFlag = true;
                    }
                }
                else if (_this.context == 'candidateCard') {
                    if (!_.isNull(message.candidateId) && (message.notifyOn.indexOf('CANDIDATE_CARD') != -1) && (message.candidateId == _this.notificationsContainer.searchObject.candidateId)) {
                        performChangeFlag = true;
                    }
                }
                else if (_this.context == 'candidateJobMatchCard') {
                    if (!_.isNull(message.jobMatchId) && (message.notifyOn.indexOf('CANDIDATE_JOB_CARD') != -1) && (message.jobMatchId == _this.notificationsContainer.searchObject.jobMatchId)) {
                        performChangeFlag = true;
                    }
                }
                else if (_this.context == 'requisitionCard') {
                    if (!_.isNull(message.jobId) && (message.notifyOn.indexOf('REQUISITION_CARD') != -1) && (message.jobId == _this.notificationsContainer.searchObject.jobId)) {
                        performChangeFlag = true;
                    }
                }
                if (performChangeFlag) {
                    message = _this.notificationsContainer.massageMessageData(message);
                    if (message.operation == 'new') {
                        var index = _.findIndex(_this.notificationsContainer.notifications, {
                            notificationId: message.notificationId
                        });
                        if (index == -1) {
                            _this.notificationsContainer.newNotifications.unshift(message);
                            _this.numberOfNewNotifications = _this.numberOfNewNotifications + 1;
                            _this.notificationsContainer.notifications.unshift(message);
                            _this.notificationsContainer.notificationsExistFlag = true;
                            // Update Notification
                            _this.updateNotification(index, message);
                        }
                        if (message.notifyOn.indexOf('JOB_BOARD_SEARCH_FAILED') != -1) {
                            var title = 'Alert!';
                            var message_1 = "We have reached the limit for the number of resume pulls from <b>" + message_1.jobBoardName + "</b>. Please talk to your administrator if you need to increase the resume pull limits for that specific Job Board.";
                            _this.alertsAndNotificationsService.showAlert(title, message_1, 'warning');
                        }
                    }
                    else if (message.operation == 'update' && message.state == "READ") {
                        var index = _.findIndex(_this.notificationsContainer.notifications, {
                            notificationId: message.notificationId
                        });
                        if (index !== -1) {
                            _this.notificationsContainer.notifications[index].state = message.state;
                            // Update Notification
                            _this.updateNotification(index, message);
                            // remove if it exists in new notifications.
                            var removedArray = _.remove(_this.notificationsContainer.newNotifications, {
                                notificationId: message.notificationId
                            });
                            if (removedArray.length > 0) {
                                _this.numberOfNewNotifications = _this.numberOfNewNotifications - 1;
                            }
                        }
                        else if (_this.context == 'global') { //the read notification may not loaded on global icon notifications
                            _this.numberOfNewNotifications = _this.numberOfNewNotifications - 1;
                        }
                    }
                }
            }
        });
    };
    UserNotificationsController.prototype.updateNotification = function (index, message) {
        if (message && message.eventType && message.eventType === 'JOB_BOARD_SEARCH_COMPLETED') {
            if (this.notificationsContainer && this.notificationsContainer.notifications && this.notificationsContainer.notifications[index]) {
                if (this.notificationsContainer.notifications[index].notificationId === message.notificationId) {
                    this.notificationsContainer.notifications[index].candidateDtoMap = message.candidateDtoMap ? message.candidateDtoMap : this.notificationsContainer.notifications[index].candidateDtoMap;
                }
            }
        }
    };
    UserNotificationsController.prototype._savePlanDetails = function () {
        var _this = this;
        this.planService.getCurrentPlan(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.$rootScope.userDetails.plan.planName = data.planHeaderDto.planName;
            _this.$rootScope.userDetails.plan.startDate = moment(data.planHeaderDto.planStartDate);
            _this.$rootScope.userDetails.plan.endDate = moment(data.planHeaderDto.planEndDate);
            _this.$rootScope.userDetails.plan.planType = data.planHeaderDto.planType;
            _this.$rootScope.userDetails.plan.message = _this.planService.getPlanExpiryMessage(_this.$rootScope.userDetails.plan.planType, _this.$rootScope.userDetails.plan.endDate, true);
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UserNotificationsController.prototype._setCompanyState = function (text) {
        var index = text.substring(0, text.length - 3).lastIndexOf("'") + 1;
        var lastIndex = text.lastIndexOf("'");
        var companyState = text.substring(index, lastIndex);
        console.log(companyState);
        this.$rootScope.userDetails.company.companyState = companyState;
        this.companyService.setCompanyStateLabel();
        if (companyState == 'Hold' && !this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
            this.$rootScope.$emit("CallLogoutMethod", {
                logoutnow: true
            });
        }
        this.StorageService.set('userDetails', angular.copy(this.$rootScope.userDetails), {
            'expires': new Date(Date.now() + this.$rootScope.tokenvalidity)
        });
    };
    UserNotificationsController.prototype._displayAssessmentsSyncMessage = function (taggedHtmlText) {
        this.sharedAjsService.displayAssessmentsSyncMessage(this._getHighlightedNotificationHTML(taggedHtmlText));
    };
    UserNotificationsController.prototype.onNotificationClicked = function ($event, notification, notificationIndex) {
        // if(this.viewAllMode == 'navigate' || this.viewAllMode == 'modal') {
        if (this.showShortNotification) {
            this.expandNotification($event, notification, notificationIndex);
        }
        // trigger the regular marking notification as read.
        this.markNotificationAsRead($event, notification);
    };
    UserNotificationsController.prototype._showAssessmentReport = function (jobMatchId, assessmentType, testInvitationId) {
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardReportModal.default,
            backdrop: 'static',
            windowClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'assessmentType', 'jobMatchId', 'testInvitationId', function ($uibModalInstance, assessmentType, jobMatchId, testInvitationId) {
                    var vm = this;
                    this.jobMatchId = jobMatchId;
                    this.assessmentType = assessmentType;
                    this.modalTitle = 'Technical Assessment Report';
                    this.context = "notification";
                    this.testInvitationId = testInvitationId;
                    if (assessmentType == 'ValueAssessment') {
                        this.modalTitle = 'Value Assessment Report';
                    }
                    this.closeModal = function () {
                        $uibModalInstance.dismiss('close');
                    };
                }],
            controllerAs: 'reportModal',
            size: 'lg',
            resolve: {
                assessmentType: function () {
                    return assessmentType;
                },
                jobMatchId: function () {
                    return jobMatchId;
                },
                testInvitationId: function () {
                    return testInvitationId;
                }
            }
        });
    };
    UserNotificationsController.prototype.markNotificationAsRead = function ($event, notification) {
        var _this = this;
        // show the full notification
        // notification.showShortMessageFlag = false;
        $event.stopPropagation();
        if (notification.state == 'NEW' || notification.state == 'VIEWED') {
            var stateObject = {
                notificationIds: [],
                state: 'READ'
            };
            stateObject.notificationIds.push(notification.notificationId);
            this.notificationsService.setNotificationsState(stateObject, function (data) {
                // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    UserNotificationsController.prototype.performAction = function (actionType) {
        var _this = this;
        var selectedUserNotifications = [];
        angular.forEach(this.notificationsContainer.notifications, function (val, key) {
            if (val.selectedFlag) {
                selectedUserNotifications.push(val);
            }
        });
        if (selectedUserNotifications.length == 0) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Notifications Selected!</strong></div>",
                message: "Please select at least one notification to perform this action.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else {
            switch (actionType) {
                case 'markAsRead':
                    var stateObject_1 = {
                        notificationIds: [],
                        state: 'READ'
                    };
                    if (this.notificationsContainer.selectAll) {
                        var markAsReadFilter = angular.copy(this.notificationsContainer.searchObject);
                        markAsReadFilter.excludedNotificationIds = this.notificationsContainer.notifications
                            .filter(function (notification) { return notification.selectedFlag == false; })
                            .map(function (notification) { return notification.notificationId; });
                        this.notificationsService.changeStateForNotificationsByFilter('READ', markAsReadFilter, function (data) {
                            // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
                            angular.forEach(selectedUserNotifications, function (val, key) {
                                val.selectedFlag = _this.notificationsContainer.selectAll;
                            });
                        }, function (error) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                    else {
                        angular.forEach(selectedUserNotifications, function (val, key) {
                            stateObject_1.notificationIds.push(val.notificationId);
                        });
                        this.notificationsService.setNotificationsState(stateObject_1, function (data) {
                            // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
                            angular.forEach(selectedUserNotifications, function (val, key) {
                                val.selectedFlag = _this.notificationsContainer.selectAll;
                            });
                        }, function (error) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                    break;
                default:
                // do nothing
            }
        }
    };
    UserNotificationsController.prototype._initializeDateAndTimePickersForFilters = function () {
        var _this = this;
        $(document).ready(function () {
            var currentDate = new Date();
            $('#userNotificationsStartDate').datepicker({
                format: "M d, yyyy",
                endDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            //$("#timeBoundStartDate").datepicker("setDate", currentDate);
            $('#userNotificationsEndDate').datepicker({
                format: "M d, yyyy",
                endDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            $('#userNotificationsStartDate').datepicker().on('changeDate', function (e) {
                _this._validateAndCorrectStartDateAndEndDate();
                _this.notificationsContainer.searchObject.startDateTime = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.searchObjectStartDate));
                _this.searchNotifications();
            });
            $('#userNotificationsEndDate').datepicker().on('changeDate', function (e) {
                _this._validateAndCorrectStartDateAndEndDate();
                _this.notificationsContainer.searchObject.endDateTime = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.searchObjectEndDate + ' 11:59:59 PM'));
                _this.searchNotifications();
            });
        });
    };
    UserNotificationsController.prototype._validateAndCorrectStartDateAndEndDate = function () {
        if (!_.isNull(this.searchObjectStartDate) && this.searchObjectStartDate != '' && !_.isNull(this.searchObjectEndDate) && this.searchObjectEndDate != '') {
            var momentOfCurrentStartDate = moment(new Date(this.searchObjectStartDate));
            var momentOfCurrentEndDate = moment(new Date(this.searchObjectEndDate));
            if (momentOfCurrentEndDate.isBefore(momentOfCurrentStartDate, 'day')) {
                // make the 'end date' as 1 days greater than 'start date'
                var defaultEndDate = momentOfCurrentStartDate.add(1, 'd').toDate();
                $("#userNotificationsEndDate").datepicker("setDate", defaultEndDate);
            }
        }
    };
    UserNotificationsController.prototype.viewAllNotifications = function () {
        var _this = this;
        if (this.viewAllMode == 'navigate') {
            this.$state.go('missioncontrol.notifications', { 'searchObject': this.notificationsContainer.searchObject, 'context': this.context }, { 'reload': true });
        }
        else if (this.viewAllMode == 'modal') {
            this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: UserNotificationActionModal.default,
                backdrop: 'static',
                keyboard: false,
                controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'context', 'searchObject', 'closeCallback', 'jobTypeList', 'salaryDurationOptions', function ($uibModalInstance, actionType, actionLabel, context, searchObject, closeCallback, jobTypeList, salaryDurationOptions) {
                        var vm = this;
                        this.actionType = actionType;
                        this.actionLabel = actionLabel;
                        this.context = context;
                        this.searchObject = searchObject;
                        this.numberOfNewNotifications = 0;
                        this.userNotificationControls = {};
                        this.userNotificationControls.setNewNotificationsAsViewed = null;
                        this.jobTypeList = jobTypeList;
                        this.salaryDurationOptions = salaryDurationOptions;
                        this.closeModal = function () {
                            $uibModalInstance.close('cancel');
                        };
                    }],
                windowTopClass: 'user-notifications-modal-large',
                controllerAs: 'userNotificationsActionModal',
                size: 'lg',
                resolve: {
                    actionType: function () {
                        return 'viewAllNotifications';
                    },
                    actionLabel: function () {
                        return 'View All Notifications';
                    },
                    searchObject: function () {
                        var searchObject = JSON.parse(_this.searchObject);
                        // change page size to 6
                        searchObject.size = 6;
                        return searchObject;
                    },
                    context: function () {
                        return _this.context;
                    },
                    closeCallback: function () {
                        return _this.init;
                    },
                    jobTypeList: function () {
                        return _this.jobTypeList;
                    },
                    salaryDurationOptions: function () {
                        return _this.salaryDurationOptions;
                    }
                }
            });
        }
    };
    UserNotificationsController.prototype.selectAllNotifications = function () {
        var _this = this;
        angular.forEach(this.notificationsContainer.notifications, function (notification, key) {
            notification.selectedFlag = _this.notificationsContainer.selectAll;
        });
    };
    UserNotificationsController.prototype.onNotificationSelectionChange = function (selectedFlag) {
        // if(!selectedFlag) {
        //     this.notificationsContainer.selectAll = false;
        // }
    };
    UserNotificationsController.prototype.expandNotification = function ($event, notification, notificationIndex) {
        notification.showShortMessageFlag = !notification.showShortMessageFlag;
        $event.stopPropagation();
        if (!notification.showShortMessageFlag) {
            this.$timeout(function () {
                scrollIntoView(document.getElementById(notification.notificationId + "-" + notificationIndex), { behavior: "smooth", block: "end", scrollMode: "if-needed" });
            }, 200);
        }
    };
    UserNotificationsController.prototype._goToCandidateDocuments = function (notification) {
        var actionType = 'candidateBooklet';
        var actionLabel = notification.documentDtoMap.fullName + "'s" + ' Booklet';
        notification.documentDtoMap.isNotification = true;
        if (notification.documentDtoMap.eventType && notification.documentDtoMap.eventType == 'DOCUMENT_EMAIL_NOTIFICATION') {
            actionType = 'emailNotification';
            actionLabel = 'Details of Documents Emailed';
        }
        this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, notification.documentDtoMap);
    };
    UserNotificationsController.prototype.goToResumeProcessedCandidates = function (notification) {
        var resumeProcessedModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            component: "uploadResumesProcessedCandidatesModal",
            windowTopClass: 'four-dot-five-modal-large',
            resolve: {
                candidatesCount: function () {
                    return notification.candidateDtoMap;
                },
                jobId: function () {
                    return notification.jobId;
                },
                candidateId: function () {
                    return notification.candidateId;
                },
                notificationId: function () {
                    return notification.notificationId;
                },
                headingTitle: function () {
                    return notification.highlightedHTMLText;
                }
            }
        });
        resumeProcessedModal.result.then(function () {
        }, function () {
        });
    };
    UserNotificationsController.prototype.goToWorkflow = function ($event, notification) {
        var _this = this;
        this.markNotificationAsRead($event, notification);
        // perform relevant actions as notification is clicked
        //Display processed resumes
        if (notification.eventType == 'JOB_SCORE_SYNC_COMPLETED') {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.candidateDtoMap.reqId,
                searchString: ''
            });
            // this.$state.go('missioncontrol.uploadreq',
            //     {
            //         jobId: notification.candidateDtoMap.reqId,
            //         jobState: notification.candidateDtoMap.reqStatus,
            //         isNewReq: notification.candidateDtoMap.isNewReq,
            //         asyncActionType: notification.candidateDtoMap.actionType
            //     });
        }
        if (notification.eventType == 'RESUME_SCORE_SYNC_COMPLETED') {
            this.goToResumeProcessedCandidates(notification);
        }
        if (notification.eventType == 'JOB_BOARD_SEARCH_COMPLETED' || (notification.jbiTransactionId && notification.jbiTransactionId)) {
            // if jbiTransactionId exists and is not null, this notification was caused because a job board pull was finished.
            var actionType_1 = 'reviewJobPull';
            var actionLabel_1 = 'Review Job Board Pull';
            var closeCallback_1 = null;
            switch (actionType_1) {
                case 'reviewJobPull':
                    closeCallback_1 = function () {
                        if ((_this.$state.current.name == 'missioncontrol.candidateJobMatchesWorkflow') && (notification.jobId == _this.$state.params.jobId)) {
                            _this.$rootScope.$broadcast('refreshJobWorkflow', null);
                        }
                    };
                    break;
                default:
                    break;
            }
            this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: UserNotificationActionModal.default,
                backdrop: 'static',
                keyboard: false,
                controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'jobId', 'jbiTransactionId', 'notificationHTMLText', 'candidateDtoMap', 'notificationId', 'closeCallback', function ($uibModalInstance, actionType, actionLabel, jobId, jbiTransactionId, notificationHTMLText, candidateDtoMap, notificationId, closeCallback) {
                        var vm = this;
                        this.jobId = jobId;
                        this.jbiTransactionId = jbiTransactionId;
                        this.actionType = actionType;
                        this.actionLabel = actionLabel;
                        this.processedHTMLText = notificationHTMLText;
                        this.candidateDtoMap = candidateDtoMap;
                        this.notificationId = notificationId;
                        if (actionType == 'reviewJobPull') {
                            this.processedHTMLText = notificationHTMLText.replace(/Finished processing/g, "Processed");
                        }
                        this.saveCallback = function () {
                            $uibModalInstance.close('cancel');
                            saveCallback();
                        };
                        this.closeModal = function () {
                            $uibModalInstance.close('cancel');
                            if (!_.isNull(closeCallback)) {
                                closeCallback();
                            }
                        };
                        this.closeCallbackModal = function () {
                            $uibModalInstance.close('cancel');
                        };
                    }],
                windowTopClass: 'four-dot-five-modal-large',
                controllerAs: 'userNotificationsActionModal',
                size: 'lg',
                resolve: {
                    jobId: function () {
                        return notification.jobId;
                    },
                    jbiTransactionId: function () {
                        return notification.jbiTransactionId;
                    },
                    notificationHTMLText: function () {
                        return notification.highlightedHTMLText;
                    },
                    actionType: function () {
                        return actionType_1;
                    },
                    actionLabel: function () {
                        return actionLabel_1;
                    },
                    closeCallback: function () {
                        return closeCallback_1;
                    },
                    candidateDtoMap: function () {
                        return notification.candidateDtoMap;
                    },
                    notificationId: function () {
                        return notification.notificationId;
                    }
                }
            });
        }
        // view Generated PDF
        if (!_.isUndefined(notification.assessmentType) && !_.isNull(notification.assessmentType)) {
            this._showAssessmentReport(notification.jobMatchId, notification.assessmentType, notification.testInvitationId);
        }
        if (!_.isNull(notification.redirect) && !notification.documentDtoMap) {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.redirect.jobId,
                searchString: notification.redirect.candidateEmail
            });
        }
        if (!_.isNull(notification.requisitionScreenRedirect) && notification.eventType === 'CANDIDATE_JOB_MATCH_RE_RUN_SCORING') {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.requisitionScreenRedirect.jobId,
                searchString: notification.requisitionScreenRedirect.candidateEmail
            });
        }
        if (!_.isNull(notification.requisitionScreenRedirect) && notification.eventType === 'REQUISITION_RE_RUN_SCORING') {
            // this.$state.go('missioncontrol.requisitions', {
            //     userParamsObject: {
            //         requisitionNumber: notification.requisitionScreenRedirect.requisitionNumber
            //     }
            // });
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.requisitionScreenRedirect.jobId,
                searchString: ''
            });
        }
        // Redirect to Candidate Documents Tab
        if (notification.documentDtoMap) {
            this._goToCandidateDocuments(notification);
        }
        if (this.closeCallback) {
            this.closeCallback();
        }
    };
    UserNotificationsController.prototype.goToCandidatesScreen = function ($event, notification) {
        this.markNotificationAsRead($event, notification);
        var redirectInfo = notification.candidateScreenRedirect;
        if (redirectInfo) {
            var candidateType = redirectInfo.vendorCandidate ? "VENDOR_CANDIDATES" : "OWN_CANDIDATES";
            this.$state.go('missioncontrol.candidates', {
                searchString: redirectInfo.candidateEmail,
                candidateType: candidateType
            });
        }
        else {
            this.$state.go('missioncontrol.candidates', null);
        }
        if (this.closeCallback) {
            this.closeCallback();
        }
    };
    UserNotificationsController.prototype.openResultsModal = function (event, notification, notificationIndex) {
        var _this = this;
        var tm = this;
        var candidateId = notification.candidateId ? notification.candidateId : notification.candidateOutreachJobMatchesInfo.candidateId;
        var candidateName = (notification.candidateOutreachJobMatchesInfo && notification.candidateOutreachJobMatchesInfo.candidateName) ? notification.candidateOutreachJobMatchesInfo.candidateName : null;
        var actionLabel = notificationIndex === 'candidateNoLongerMatch' ? 'Reasons for Candidate Mismatch' : "Job Matches " + (candidateName ? "for <b>'" + candidateName + "'</b>" : "");
        var actionType = notificationIndex === 'candidateNoLongerMatch' ? 'candidateNoLongerMatch' : 'outreachNoResponse';
        var windowClass = notificationIndex === 'candidateNoLongerMatch' ? 'four-dot-five-modal-small' : 'four-dot-five-modal-large';
        var isOutreachExpiryDataExists = notification.isOutreachExpiryDataExists;
        var allJobMatchesDisabled = tm.checkIfAllDisabled(notification.candidateOutreachJobMatchesInfo.jobMatches);
        var isSendOutreachAgainEnabled = notification.eventType.includes('REMINDER') || notification.eventType.includes('EXPIRY') || notification.eventType.includes('EXPIRED');
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UserNotificationActionModal.default,
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'notification', 'closeCallback', 'isStaffingCompany', 'jobTypeList', 'salaryDurationOptions', 'isOutreachExpiryDataExists', 'candidateId', 'selectAllJobMatches', 'allJobMatchesDisabled', 'isSendOutreachAgainEnabled',
                function ($uibModalInstance, actionType, actionLabel, notification, closeCallback, isStaffingCompany, jobTypeList, salaryDurationOptions, isOutreachExpiryDataExists, candidateId, selectAllJobMatches, allJobMatchesDisabled, isSendOutreachAgainEnabled) {
                    var _this = this;
                    var vm = this;
                    this.actionType = actionType;
                    this.actionLabel = actionLabel;
                    '';
                    this.userNotificationControls = {};
                    this.userNotificationControls.setNewNotificationsAsViewed = null;
                    this.notification = notification;
                    this.isStaffingCompany = isStaffingCompany;
                    this.jobTypeList = jobTypeList;
                    this.salaryDurationOptions = salaryDurationOptions;
                    this.isOutreachExpiryDataExists = isOutreachExpiryDataExists;
                    this.candidateId = candidateId;
                    this.selectAllJobMatches = selectAllJobMatches;
                    this.allJobMatchesDisabled = allJobMatchesDisabled;
                    this.isSendOutreachAgainEnabled = isSendOutreachAgainEnabled;
                    this.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    this.openModalCallback = function (jobMatch) {
                        tm.openModal(jobMatch, 'jobProfile', _this.candidateId);
                    };
                    this.openJobCompareModalCallback = function (jobMatch) {
                        tm.openModal(jobMatch, 'jobCompare', _this.candidateId);
                    };
                    this.onJobMatchSelectionChange = function (jobMatches) {
                        if (jobMatches && jobMatches.length > 0) {
                            var enabled = jobMatches.filter(function (jm) { return !jm.outreachDisabled; });
                            _this.selectAllJobMatches = enabled.length > 0 &&
                                enabled.every(function (jm) { return jm.jobMatchSelected === true; });
                        }
                        else {
                            _this.selectAllJobMatches = false;
                        }
                    };
                    this.toggleSelectAllJobMatches = function (jobMatches) {
                        if (jobMatches && jobMatches.length > 0) {
                            jobMatches.forEach(function (jm) {
                                jm.jobMatchSelected = !jm.outreachDisabled && _this.selectAllJobMatches;
                            });
                        }
                    },
                        this.sendCandidateOutreachAgain = function (jobMatches) {
                            tm.sendSelectedJobMatchOutreachEmail(jobMatches, _this.candidateId, _this.notification.candidateType, _this.notification.clientOrBuId, function () {
                                _this.closeModal();
                            });
                        };
                }],
            windowTopClass: windowClass,
            controllerAs: 'userNotificationsActionModal',
            size: 'sm',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                notification: function () {
                    return notification;
                },
                closeCallback: function () {
                    return _this.init;
                },
                isStaffingCompany: function () {
                    return _this.isStaffingCompany;
                },
                jobTypeList: function () {
                    return _this.jobTypeList;
                },
                salaryDurationOptions: function () {
                    return _this.salaryDurationOptions;
                },
                isOutreachExpiryDataExists: function () {
                    return isOutreachExpiryDataExists;
                },
                candidateId: function () {
                    return candidateId;
                },
                selectAllJobMatches: function () {
                    return false;
                },
                allJobMatchesDisabled: function () {
                    return allJobMatchesDisabled;
                },
                isSendOutreachAgainEnabled: function () {
                    return isSendOutreachAgainEnabled;
                }
            }
        });
        this.$timeout(function () {
            // Nested Modal Issue - To be fixed in future
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("user-notifications-modal-large");
            $(".modal.four-dot-five-modal-small.in").removeClass("user-notifications-modal-large");
        }, 1);
    };
    UserNotificationsController.prototype._getHighlightedNotificationHTML = function (text) {
        var newText = text.replace(/<4dot5>/g, "<span class='emerald'>");
        return newText ? newText.replace(/<\/4dot5>/g, "</span>") : "";
    };
    UserNotificationsController.prototype._getClientsOrBus = function (successCallback) {
        var _this = this;
        this.loadingClientsOrBUs = true;
        var requisitionId = null;
        var isFromCreateReq = false;
        this.requisitionService.getAllClientsOrBu(this.$rootScope.userDetails, requisitionId, isFromCreateReq, function (data) {
            _this._setClientsOrBus(data);
            _this.loadingClientsOrBUs = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingClientsOrBUs = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UserNotificationsController.prototype._setClientsOrBus = function (clientsOrBus) {
        this.fullClientsList = clientsOrBus;
        angular.forEach(this.fullClientsList, function (clientOrBu, key) {
            if (clientOrBu.companyType == 'Corporation') {
                clientOrBu.name = "<span style='padding-right:5px;'>" + clientOrBu.name + "</span><i class='fas fa-share-alt'></i>";
            }
        });
        this.fullClientsListCopy = angular.copy(this.fullClientsList);
        // if(this.savedFilters !== null){
        //     this.selectedClients = this.fullClientsList.filter(clientOrBu => this.savedFilters.clientOrBU.some(selectedId => clientOrBu.id == selectedId));
        //     this.selectedClients.forEach(clientOrBu => clientOrBu.ticked = true);
        // }
    };
    UserNotificationsController.prototype.onClientClick = function () {
        var _this = this;
        this._getRoles("all", function () {
            _this.getRequisitionNumbers("all", function () {
                _this.searchNotifications();
            });
        });
    };
    UserNotificationsController.prototype.onRoleClick = function () {
        var _this = this;
        this.getRequisitionNumbers("all", function () {
            _this.searchNotifications();
        });
    };
    UserNotificationsController.prototype.onRequisitionNumberClick = function () {
        this.searchNotifications();
    };
    UserNotificationsController.prototype._getRoles = function (searchReqText, successCallback) {
        var _this = this;
        this.loadingRoles = true;
        this.fullRolesList = [];
        this.selectedRoles = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        else {
            this.searchReqText = searchReqText;
        }
        var clientOrBuIds = this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
        this.jobService.getRoles(this.userId, this.companyId, this.searchReqText, { clientOrBuIds: clientOrBuIds }, function (data) {
            _this._setRoles(data);
            _this.loadingRoles = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingRoles = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UserNotificationsController.prototype._setRoles = function (roles) {
        var _this = this;
        angular.forEach(roles, function (val, key) {
            var roleObj = { "name": val };
            if (!_this._containsObject(roleObj, _this.fullRolesList, "name")) {
                if (val !== null)
                    roleObj.selectedDisplayName = _this.$filter('displayOnMultiSelectFilter')(val);
                _this.fullRolesList.push(roleObj);
            }
            _this.fullRolesListCopy = angular.copy(_this.fullRolesList);
        });
        // if(this.savedFilters !== null){
        //     this.selectedRoles = this.fullRolesList.filter(role => this.savedFilters.roleList.some(roleName => role.name == roleName));
        //     this.selectedRoles.forEach(role => role.ticked = true);
        // }
    };
    UserNotificationsController.prototype.getRequisitionNumbers = function (searchReqText, successCallback) {
        var _this = this;
        this.loadingRequisitionNumbers = true;
        this.fullReqNumList = [];
        this.selectedRequisitionNumbers = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        this.searchReqText = searchReqText;
        var clientOrBuIds = this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
        var roleNames = this.selectedRoles.map(function (role) { return role.name; });
        var reqNumberFilter = { clientOrBuIds: clientOrBuIds, roleNames: roleNames };
        this.jobService.searchByReqNum(this.userId, this.companyId, this.searchReqText, reqNumberFilter, function (data) {
            _this._setRequisitionNumbers(data);
            if (searchReqText == "all") {
                _this.fullReqNumListCopy = angular.copy(_this.fullReqNumList);
            }
            _this.loadingRequisitionNumbers = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingRequisitionNumbers = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UserNotificationsController.prototype._setRequisitionNumbers = function (requisitionNumbers) {
        var modifiedRequisitionNumbers = [];
        for (var i = 0; i < requisitionNumbers.length; i++) {
            var icon = requisitionNumbers[i].sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
            var obj = { name: requisitionNumbers[i].reqNumber, icon: icon };
            // if(!this._containsObject(obj, modifiedRequisitionNumbers, "name")) {
            obj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(obj.name);
            modifiedRequisitionNumbers.push(obj);
            // }
        }
        for (var i = 0; i < modifiedRequisitionNumbers.length; i++) {
            for (var j = 0; j < this.selectedRequisitionNumbers.length; j++) {
                if (modifiedRequisitionNumbers[i].name == this.selectedRequisitionNumbers[j].name) {
                    modifiedRequisitionNumbers[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullReqNumList = angular.copy(modifiedRequisitionNumbers);
        // if(this.savedFilters !== null){
        //     this.selectedRequisitionNumbers = this.fullReqNumList.filter(reqNumber => this.savedFilters.requisitionNums.some(num => num == reqNumber.name));
        //     this.selectedRequisitionNumbers.forEach(num => num.ticked = true);
        // }
    };
    UserNotificationsController.prototype.selectRemoveAll = function (label, type) {
        this._setFiltersAndFetchJobs(label, type);
    };
    UserNotificationsController.prototype._setFiltersAndFetchJobs = function (label, type) {
        if (type === 'selectAll') {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.selectedClients = tslib_1.__spread(this.fullClientsList);
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.selectedRoles = tslib_1.__spread(this.fullRolesList);
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.selectedRequisitionNumbers = tslib_1.__spread(this.fullReqNumList);
                this.onRequisitionNumberClick();
            }
        }
        else {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.fullClientsList.forEach(function (clientOrBU) { return clientOrBU.ticked = false; });
                this.selectedClients = [];
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.fullRolesList.map(function (role) { return role.ticked = false; });
                this.selectedRoles = [];
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.fullReqNumList.map(function (num) { return num.ticked = false; });
                this.selectedRequisitionNumbers = [];
                this.onRequisitionNumberClick();
            }
        }
    };
    UserNotificationsController.prototype._containsObject = function (obj, list, key) {
        for (var index in list) {
            var currentObject = list[index];
            for (var prop in currentObject) {
                if (prop === key && currentObject.hasOwnProperty(prop)
                    && currentObject[prop] === obj[prop]) {
                    return true;
                }
            }
        }
        return false;
    };
    UserNotificationsController.prototype.getNotificationTypes = function () {
        var _this = this;
        this.loadingNotificationTypes = true;
        this.notificationsService.getNotificationTypes(function (data) {
            _this.alertTypes = data;
            _this.loadingNotificationTypes = false;
        }, function (error) {
            _this.loadingNotificationTypes = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UserNotificationsController.prototype.openModal = function (jobMatch, actionType, candidateId) {
        var _this = this;
        var actionLabel = actionType === 'jobProfile' ? 'Job Profile' : 'Candidate Job Comparison';
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UserNotificationActionModal.default,
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'notification', 'candidateId', function ($uibModalInstance, actionType, actionLabel, notification, candidateId) {
                    var vm = this;
                    this.actionType = actionType;
                    this.actionLabel = actionLabel;
                    this.notification = notification;
                    this.candidateId = candidateId;
                    this.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            windowTopClass: 'four-dot-five-modal-large',
            controllerAs: 'userNotificationsActionModal',
            size: 'sm',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                notification: function () {
                    return jobMatch;
                },
                candidateId: function () {
                    return candidateId;
                },
                closeCallback: function () {
                    return _this.init;
                }
            }
        });
        // this.$timeout(() => {
        //     // Nested Modal Issue - To be fixed in future
        //     this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        //     $(".modal").addClass("user-notifications-modal-large");
        //     $(".modal.four-dot-five-modal-small.in").removeClass("user-notifications-modal-large");
        // }, 1);
    };
    UserNotificationsController.prototype.checkIfAllDisabled = function (jobMatches) {
        if (!jobMatches || jobMatches.length === 0) {
            return true;
        }
        return jobMatches.every(function (jm) { return jm.outreachDisabled === true; });
    };
    ;
    UserNotificationsController.prototype.sendSelectedJobMatchOutreachEmail = function (jobMatches, candidateId, candidateType, clientOrBuId, successCallback) {
        var _this = this;
        var selectedJobMatches = jobMatches.filter(function (jobMatch) { return (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled); });
        if (selectedJobMatches.length === 0) {
            this.alertsAndNotificationsService.showAlert('No Selection', 'Please select at least One Job Match to Send Outreach to Candidate.', 'warning');
            return;
        }
        else {
            var outreachObject = {};
            var candidateIds = [
                {
                    id: candidateId,
                    candidateType: candidateType ? candidateType : 'OWN_CANDIDATES',
                    source: 'CANDIDATE_CARD',
                    jobIds: jobMatches.filter(function (jobMatch) { return (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled); }).map(function (jobMatch) { return jobMatch.jobId; }),
                    jobMatchId: ""
                }
            ];
            outreachObject = {
                candidates: candidateIds,
                userId: this.userId,
                companyId: this.companyId,
                clientOrBuId: clientOrBuId ? clientOrBuId : jobMatches[0].clientOrBuId ? jobMatches[0].clientOrBuId : ''
            };
            this.candidateService.sendOutreachEmail(outreachObject, function (data) {
                _this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                if (successCallback) {
                    successCallback();
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    return UserNotificationsController;
}());
var SearchObject = /** @class */ (function () {
    function SearchObject(companyId, showFilters) {
        this.companyId = companyId;
        this.page = "";
        this.size = 3;
        this.notifyOn = 'GLOBAL';
        if (showFilters) {
            this.alertType = null;
            this.startDateTime = null;
            this.endDateTime = null;
            this.firstName = null;
            this.lastName = null;
            this.jobTitle = null;
            this.clientName = null;
            this.requisitionNumber = null;
            this.onlyUnreadNotifications = false;
            clientOrBuIds = [];
            roleNames = [];
            reqNumbers = [];
        }
    }
    return SearchObject;
}());
UserNotificationsController.$inject = ['$rootScope', '$state', '$filter', '$uibModal', '$timeout', 'StorageService', 'planService', 'companyService', 'requisitionService', 'jobService', 'userRoleService', 'utilityService', 'debounceService', 'alertsAndNotificationsService', 'webSocketsService', 'dateTimeUtilityService', 'MESSAGECONSTANTS', 'notificationsService', 'sharedAjsService', 'modalService', 'outreachService', 'candidateService'];
// import * as TEMPLATE from '.user-notifications.html';
import * as TEMPLATE from 'raw-loader!./user-notifications.html';
export var UserNotificationsComponent = {
    selector: 'userNotifications',
    component: {
        bindings: {
            height: '@',
            width: '@',
            numberOfNewNotifications: '=',
            searchObject: '@',
            viewAllFlag: '@',
            viewAllMode: '@',
            context: '@',
            userNotificationControls: '=',
            showFilters: '<',
            showShortNotification: '=',
            notificationClicked: '<',
            fullView: '<',
            closeCallback: '&',
            jobTypeList: '<',
            salaryDurationOptions: '<'
        },
        template: TEMPLATE.default,
        controller: UserNotificationsController
        // templateUrl: 'app/shared/userNotifications/user-notifications.html'
    }
};
var NotificationsContainer = /** @class */ (function () {
    function NotificationsContainer($rootScope, context, showShortNotification, searchObject, showFilters, fullView, alertsAndNotificationsService, notificationsService, isStaffingCompany, outreachService) {
        this.$rootScope = $rootScope;
        this.context = context;
        this.showShortNotification = showShortNotification;
        this.searchObject = searchObject;
        this.showFilters = showFilters;
        this.fullView = fullView;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.notificationsService = notificationsService;
        this.isStaffingCompany = isStaffingCompany;
        this.outreachService = outreachService;
        this.$onInit();
    }
    NotificationsContainer.prototype.$onInit = function () {
        this.notifications = [];
        this.newNotifications = [];
        this.busy = false;
        this.isNotificationIconClicked = false;
        this.notificationsExistFlag = true;
        this.searchObject = _.isUndefined(this.searchObject) ? new SearchObject(this.$rootScope.userDetails.company.companyId, this.showFilters) : (_.isObject(this.searchObject) ? this.searchObject : JSON.parse(this.searchObject));
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.isFilterOn = false;
        this.selectAll = false;
        this.originalNotificationCount = 0;
        this.filteredNotificationCount = 0;
    };
    NotificationsContainer.prototype.getNext = function (parentRef) {
        var _this = this;
        if (this.busy) {
            // getNext: Already busy, returning early
            return;
        }
        this.busy = true;
        if (this.searchObject.page == '') {
            this.searchObject.page = 1;
        }
        this.searchObject.companyId = this.$rootScope.userDetails.company.companyId;
        //Avoid page 1 being called the second time when the notifications on the card is clicked and expanded
        if (this.searchObject.page == 1 && this.notifications.length > 0) {
            this.searchObject.page = 2;
        }
        var tempSearchObject = angular.copy(this.searchObject);
        this._setIsFilterOn();
        this.currentPromise = this.notificationsService.getNotifications(tempSearchObject, function (data) {
            if (angular.isDefined(data) && data != 'user cancellation' && angular.isDefined(data.notifications)) {
                // Track unfiltered count before applying global filter
                var originalCount = data.notifications.length;
                if (data.notifications.length > 0) {
                    if (_this.context == 'global') {
                        data.notifications = data.notifications.filter(function (notification) {
                            if (notification.notifyOn) {
                                return notification.notifyOn.indexOf('NO_GLOBAL') == -1;
                            }
                            else {
                                return true;
                            }
                        });
                    }
                    parentRef.numberOfNewNotifications = data.unreadNotificationCount;
                    angular.forEach(data.notifications, function (val, key) {
                        val = _this.massageMessageData(val);
                        // push new notifications into the new notifications array
                        if (val.state == 'NEW' || val.state == 'VIEWED') {
                            _this.newNotifications.push(val);
                        }
                        //handle duplicate if notification is already got from web socket
                        if (val.operation == 'new') {
                            var index = _.findIndex(_this.notifications, {
                                notificationId: _this.notificationId
                            });
                            if (index == -1) {
                                _this.notifications.push(val);
                            }
                        }
                        else {
                            _this.notifications.push(val);
                        }
                    });
                    console.log('Notification Icon clicked: ' + _this.isNotificationIconClicked);
                    if (_this.searchObject.page > 1 && _this.isNotificationIconClicked) {
                        _this.setNewNotificationsAsViewed();
                    }
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if ((!_this.fullView && !_this.isNotificationIconClicked) || (originalCount < _this.searchObject.size)) {
                        _this.disableInfiniteScroll = true;
                    }
                    else {
                        _this.disableInfiniteScroll = false;
                        _this.searchObject.page++;
                    }
                    _this.originalNotificationCount = originalCount;
                    _this.filteredNotificationCount = data.notifications.length;
                    _this.notificationCalledOnce++;
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    _this.disableInfiniteScroll = true;
                }
                // set the notifications exist flag based on existence of notifications.
                if (_this.notifications.length > 0) {
                    _this.notificationsExistFlag = true;
                }
                else {
                    _this.notificationsExistFlag = false;
                }
            }
            //set this.busy to false
            _this.busy = false;
        }, function (error) {
            // getNext: Error callback, setting busy to false. Error:
            _this.busy = false;
            // Disable infinite scroll on error to prevent continuous retry
            _this.disableInfiniteScroll = true;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            _this.busy = false;
        });
    };
    NotificationsContainer.prototype._setIsFilterOn = function () {
        var filter = this.searchObject;
        if ((filter.clientOrBuIds !== undefined && filter.clientOrBuIds.length > 0)
            || (filter.reqNumbers !== undefined && filter.reqNumbers.length > 0)
            || (filter.roleNames !== undefined && filter.roleNames.length > 0)
            || (filter.alertType !== undefined && filter.alertType.length > 0)
            || (filter.firstName !== undefined && filter.firstName.length > 0)
            || (filter.lastName !== undefined && filter.lastName.length > 0)) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    };
    NotificationsContainer.prototype.massageMessageData = function (message) {
        var _this = this;
        if (_.isNull(message.state)) {
            message.state = 'NEW';
        }
        if (message.candidateDtoMap) {
            var date = moment(message.createdDate).format("MMM DD, YYYY hh:mm A");
            message.taggedText = message.taggedText.split('at <4dot5>')[0] + " at <4dot5>'" + date + "'</4dot5>";
        }
        message.createdDate = new Date(message.createdDate);
        message.selectedFlag = this.selectAll;
        if (!_.isNull(message.taggedText)) {
            message.highlightedHTMLText = this._getHighlightedNotificationHTML(message.taggedText);
        }
        else {
            message.highlightedHTMLText = message.text;
        }
        message.showShortMessageFlag = this.showShortMessagesFlag;
        message.showRedirect = false;
        message.showCandidateScreenRedirect = false;
        if (!_.isNull(message.redirect) && message.redirect.screenName == 'CANDIDATE_WORKFLOW' && !_.isNull(message.redirect.candidateName)) {
            message.showRedirect = true;
        }
        if ((!_.isUndefined(message.jbiTransactionId) && !_.isNull(message.jbiTransactionId)) || (!_.isUndefined(message.assessmentType) && !_.isNull(message.assessmentType))) {
            message.showRedirect = true;
        }
        if (!_.isNull(message.candidateScreenRedirect) && message.candidateScreenRedirect !== undefined && this.context == 'global') {
            message.showCandidateScreenRedirect = true;
        }
        if (!message.candidateScreenRedirect && (this.context == 'global' && (message.eventType && message.eventType === 'COMPANY_RE_RUN_SCORING'))) {
            message.showCandidateScreenRedirect = true;
        }
        if ((message.candidateDtoMap || message.documentDtoMap) && (message.eventType && !message.eventType.includes('RE_RUN_SCORING'))) {
            message.showRedirect = true;
        }
        if (message.requisitionScreenRedirect) {
            message.showRedirect = true;
        }
        if (message.reasons && message.reasons.length > 0 && message.eventType.includes('CANDIDATE_NO_LONGER_MATCHES')) {
            message.reasons = message.reasons.map(function (reason) {
                var matches = reason.match(/<4dot5>(.*?)<\/4dot5>/g);
                if (matches && matches.length > 0) {
                    for (var i = 0; i < matches.length; i++) {
                        var fullTag = matches[i]; // match with <4dot5>2025-10-07T12:20:29.760Z</4dot5>
                        var value = fullTag.replace(/<\/?4dot5>/g, ''); // extract inner value
                        // Check if it's a valid ISO date
                        if (moment(value, moment.ISO_8601, true).isValid()) {
                            var formatted = moment(value).format('MMM D, YYYY h:mm A');
                            reason = reason.replace(fullTag, '<4dot5>' + formatted + '</4dot5>');
                        }
                    }
                }
                return _this._getHighlightedNotificationHTML(reason);
            });
            message.showNoLongerMatchResults = true;
        }
        var outreachEventTypes = [
            "OUTREACH_SAVED",
            "OUTREACH_COMPLETED",
            "OUTREACH_SENT",
            "OUTREACH_NO_RESPONSE_EXPIRED",
            "OUTREACH_RESPONSE_EXPIRED",
            "OUTREACH_NOT_COMPLETED_EXPIRED",
            "OUTREACH_COMPLETION_EXPIRED",
            "OUTREACH_RESPONSE_REMINDER",
            "OUTREACH_COMPLETION_REMINDER"
        ];
        if (outreachEventTypes.includes(message.eventType) && message.candidateOutreachJobMatchesInfo) {
            if (typeof message.candidateOutreachJobMatchesInfo === 'string') {
                message.candidateOutreachJobMatchesInfo = JSON.parse(message.candidateOutreachJobMatchesInfo);
            }
            if (message.candidateOutreachJobMatchesInfo.jobMatches && message.candidateOutreachJobMatchesInfo.jobMatches.length > 0) {
                message.showOutreachNoResponseIcon = true;
                this.setOutreachJobMatchDetails(message);
            }
        }
        return message;
    };
    NotificationsContainer.prototype._getHighlightedNotificationHTML = function (text) {
        var newText = text.replace(/<4dot5>/g, "<span class='emerald'>");
        return newText ? newText.replace(/<\/4dot5>/g, "</span>") : '';
    };
    NotificationsContainer.prototype.setNewNotificationsAsViewed = function () {
        var _this = this;
        if (this.showShortNotification) {
            this._setNotificationsAsShort();
        }
        this.isNotificationIconClicked = true;
        console.log('Set this.setNewNotificationsAsViewed() called');
        if (this.newNotifications.length > 0) {
            var stateObject_2 = {
                notificationIds: [],
                state: 'VIEWED'
            };
            angular.forEach(this.newNotifications, function (val, key) {
                stateObject_2.notificationIds.push(val.notificationId);
            });
            this.notificationsService.setNotificationsState(stateObject_2, function (data) {
                // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    NotificationsContainer.prototype._setNotificationsAsShort = function () {
        angular.forEach(this.notifications, function (notification, key) {
            notification.showShortMessageFlag = true;
        });
    };
    NotificationsContainer.prototype.setOutreachJobMatchDetails = function (message) {
        var _this = this;
        message.candidateOutreachJobMatchesInfo.jobMatches.forEach(function (jobMatch) {
            _this.outreachService.setCompanyLocationLabel(jobMatch, _this.isStaffingCompany);
            jobMatch.missingOrNonMatched = _this.outreachService.setMissedOrMatchedInfo(jobMatch.missingOrNonMatchedInfo, jobMatch.workLocations);
            jobMatch.formattedOutreachStatus = _this.outreachService.formatOutreachStatus(jobMatch.outreachStatus);
            jobMatch.jobDetails = _this.outreachService.setJobDetailsLabel(jobMatch, _this.jobTypeList, _this.salaryDurationOptions);
            jobMatch.daysSinceOutreach = _this.outreachService.setDaysSinceOutreach(jobMatch);
            jobMatch.candidateMatch = _this.outreachService.setCandidateMatchingLabel(jobMatch);
            jobMatch.outreachExpiryDate = _this.outreachService.setOureachExpiryDate(jobMatch, message);
            jobMatch.isScoreMatched = (jobMatch.score && jobMatch.thresholdScore) ? jobMatch.score >= jobMatch.thresholdScore : false;
        });
        message.isOutreachExpiryDataExists = message.eventType.includes('EXPIRY') || message.candidateOutreachJobMatchesInfo.jobMatches.some(function (jm) { return jm.outreachExpiryDate; });
    };
    return NotificationsContainer;
}());
//# sourceMappingURL=user-notifications.component.js.map